import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  Input,
} from "@altimateai/lego";
import { Link } from "react-router-dom";
import { Control } from "react-hook-form";
import { Stack } from "@altimateai/lego";
import { SnowflakeFormValues } from "../SnowflakeConnection";

interface AccountFormFieldProps {
  control: Control<SnowflakeFormValues>;
}

export const AccountFormField = ({ control }: AccountFormFieldProps) => {
  return (
    <FormField
      control={control}
      name="account"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            <Stack align="center">
              Account{" "}
              <Link
                className="al-text-blue-500 hover:al-text-blue-600"
                to="https://docs.snowflake.com/en/user-guide/organizations-gs#label-viewing-organization-name"
                target="_blank"
                rel="noopener noreferrer"
              >
                (Snowflake documentation)
              </Link>
            </Stack>
          </FormLabel>
          <FormControl>
            <Input {...field} placeholder="eufpinx-tyb12513" className="al-mt-1" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
